import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import blogServices from "../../apiServices/blogServices";
import "./style.css";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};

const formatReadTime = (blog) => {
  if (blog.blogReadTime) return `${blog.blogReadTime} min read`;
  const words = (blog.metaExcerpt || "").trim().split(/\s+/).length;
  return `${Math.max(1, Math.ceil(words / 200))} min read`;
};

const BlogSection = () => {
  const [blogs, setBlogs] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const fetchBlogs = async () => {
      try {
        const blogsRes = await blogServices.getAllBlogs({
          forCeoWebsite: true,
          take: 6,
        });

        if (isMounted) {
          setBlogs(blogsRes?.data?.data?.blogs || []);
          setLoaded(true);
        }
      } catch (error) {
        if (isMounted) setLoaded(true);
      }
    };

    fetchBlogs();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <section className="tp-blog-section ceo-blog-section section-padding" id="blogs">
      <div className="container">
        <div className="tp-section-title">
          <span>Blog</span>
          <h2>Latest Insights &amp; Articles</h2>
        </div>

        {!loaded ? (
          <div className="blog-empty-state">
            <p>Loading blogs...</p>
          </div>
        ) : blogs.length === 0 ? (
          <div className="blog-empty-state">
            <p>No blogs found. Check back soon for new articles.</p>
          </div>
        ) : (
          <div className="tp-blog-items blog-grid">
            <div className="row">
              {blogs.map((blog) => {
                const image = blog.blogImages?.[0]?.image;
                const altText = blog.blogImages?.[0]?.altText;

                return (
                  <div
                    className="col-xl-4 col-lg-6 col-sm-12 col-12"
                    key={blog.blogId}
                  >
                    <div className="tp-blog-item">
                      <div className="tp-blog-img">
                        <Link to={`/blog/${blog.slug || blog.blogId}`}>
                          {image ? (
                            <img src={image} alt={altText || blog.title} />
                          ) : (
                            <div className="blog-img-placeholder" />
                          )}
                        </Link>
                      </div>
                      <div className="tp-blog-content">
                        <ul>
                          <li>{formatDate(blog.publishedDateTime)}</li>
                          <li>{formatReadTime(blog)}</li>
                        </ul>
                        <h2>
                          <Link to={`/blog/${blog.slug || blog.blogId}`}>
                            {blog.title}
                          </Link>
                        </h2>
                        {blog.metaExcerpt && <p>{blog.metaExcerpt}</p>}
                        <Link
                          to={`/blog/${blog.slug || blog.blogId}`}
                          className="blog-read-more"
                        >
                          Read More &#8594;
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      <div className="visible-rotate-text">
        <h1>Blog</h1>
      </div>
    </section>
  );
};

export default BlogSection;
